import { Spinner } from './Spinner';
import { BaseScene } from './BaseScene';
import { AudioManager } from './utilities/AudioManager';

export class SpinScene extends BaseScene {
  private drawResult: any;
  constructor() {
    super('SpinScene', false);
  }
  preload() {
    const config = window._po_gm.config;
    this.drawResult = config?.drawResult ? config.drawResult : [];
  }
  createBody() {
    new Spinner(this, this.screenWidth, this.screenHeight, this.drawResult);
    AudioManager.getInstance().playSoundEffect(this.scene.scene, 'wheel');
  }

  stop() {
    AudioManager.getInstance().stopSoundEffect(this.scene.scene, 'wheel');
  }
}
